// extracted by mini-css-extract-plugin
export var parcelRow = "_qz-0";